import React from 'react'
import PropTypes from 'prop-types'
import { Route, Redirect } from 'react-router-dom'
import Loadable from 'react-loadable'

export const Helmet = Loadable({
  loader: () => import('react-helmet'),
  loading: () => null,
})

class RoutePrivate extends React.Component {
  render() {
    const {
      component: Component,
      isAuthenticated,
      twoFAEnabled,
      twoFAVerified,
      to,
      appSetting,
      ...rest
    } = this.props

    // console.log("🔍 RoutePrivate props:", {
    //   path: rest.path,
    //   isAuthenticated,
    //   twoFAEnabled,
    //   twoFAVerified,
    // })
    const isLocked = localStorage.getItem("app_locked") === "true"



    return (
      <Route
        {...rest}
        render={(props) => {
          // console.log("➡ Current pathname:", props.location.pathname)
          const currentPath = props.location.pathname
          // 1️⃣ Jika user login & 2FA aktif & belum verifikasi
          if (twoFAEnabled && !twoFAVerified) {
            // console.log("🔐 MASUK KE KONDISI 1 (2FA belum verifikasi)")

            if (props.location.pathname !== "/2fa") {
              // console.log("👉 Redirecting ke /2fa")
              return <Redirect to="/2fa" />
            } else {
              // console.log("✔ Sudah di halaman /2fa, lanjut render")
            }
          }

          // 2️⃣ Cek autentikasi normal
          if (!isAuthenticated && !twoFAEnabled) {
            // console.log("🚫 MASUK KE KONDISI 2 (belum login dan bukan 2FA mode)")
            // console.log("👉 Redirecting ke /login")
            return (
              <Redirect
                to={{
                  pathname: to,
                  state: { redirect: props.location.pathname },
                }}
              />
            )
          }

          if (isLocked && currentPath !== "/lock-screen") {
            return (
              <Redirect
                to={{
                  pathname: "/lock-screen",
                  state: {
                    callback_url: props.location.pathname + props.location.search
                  }
                }}
              />
            )
          }


          // 3️⃣ Semua OK → render halaman\

          // console.log("✅ MASUK KE KONDISI 3 (akses diizinkan)")

          return (
            <React.Fragment>
              <Helmet
                defer={false}
                htmlAttributes={{ lang: 'en' }}
                encodeSpecialCharacters
                defaultTitle={`PT. SARANA KAWAN SETIA - BILLING SYSTEM`}
                titleAttributes={{ itemprop: 'name', lang: 'en' }}
              />
              <Component
                avaiableMenu={appSetting?.menus}
                appSetting={appSetting}
                {...props}
              />
            </React.Fragment>
          )
        }}
      />
    )
  }
}

RoutePrivate.propTypes = {
  isAuthenticated: PropTypes.bool.isRequired,
  twoFAEnabled: PropTypes.bool,
  twoFAVerified: PropTypes.bool,
  to: PropTypes.string,
}

RoutePrivate.defaultProps = {
  to: '/login',
}

export default RoutePrivate
